import { makeStyles } from 'tss-react/mui';
import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';
import { TRANSPARENT_BLACK_10, TRANSPARENT_BLACK_20 } from 'utilities/colors';

export const useTeamCardStyles = makeStyles()(() => ({
  backButton: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '1rem',
    fontSize: '1.1rem',
    letterSpacing: '0.075em',
    border: `1px solid ${TRANSPARENT_BLACK_10}`,
    color: 'rgba(0, 0, 0, 1)',
    height: '2.25rem',
  },
  usersList: {
    padding: '1rem 2rem',
    borderBottom: `1px solid ${TRANSPARENT_BLACK_20}`,
  },
  infoRow: {
    borderBottom: `1px solid ${TRANSPARENT_BLACK_20}`,
    padding: '1rem 0 1rem 2rem',
    width: '100%',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  inviteMemberButton: {
    marginLeft: 'auto',
  },
  usersContainer: {
    width: '100%',
    minHeight: '15vh',
    maxHeight: '40vh',
    overflowY: 'scroll',
    ...VERTICAL_SCROLL_STYLE,
  },
  spinnerContainer: {
    height: '30vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  darkGray: {
    opacity: 0.4,
  },
  plusIcon: {
    marginRight: '0.5rem',
  },
}));
